import addModal from './addModal.vue';
import { claimsTypeList, claimsTypeDelete, claimsTypeDetail, claimsTypeUpdate } from './request';
import { columns, REPLACE_DEPARTMENT_FIELDS, statusSelectList } from './utils';
export default {
  components: {
    addModal
  },
  data() {
    return {
      statusSelectList,
      REPLACE_DEPARTMENT_FIELDS,
      columns,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      form: {
        name: '',
        status: ''
      },
      tableData: []
    };
  },
  created() {
    this.searchFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = this.pagination.page = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await claimsTypeList(Object.assign(this.form, {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.page -= 1;
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    onAdd(type, record) {
      this.$refs.addRef.openModal(type, record, true);
    },
    async onEdit(id) {
      const res = await claimsTypeDetail({
        claimsTypeId: id
      });
      this.$refs.addRef.openModal('edit', res, false);
    },
    async onDelete({
      status,
      claimsTypeId
    }) {
      if (status === 1) {
        this.$message.warn(this.$t('请先禁用类型再删除'));
      } else {
        await this.$alert(this.$t('是否确认删除?'), {
          confirmButtonText: this.$t('确定')
        });
        await claimsTypeDelete({
          claimsTypeId: claimsTypeId
        });
        this.$message.success(this.$t('删除成功'));
        this.getListData();
      }
    },
    tablePageChange(val) {
      this.pagination = val;
      this.pagination.page = val.current;
      this.getListData();
    },
    async switchChange(checked, id) {
      await claimsTypeUpdate({
        claimsTypeId: id,
        status: checked ? 1 : 0
      });
      this.$message.success(this.$t('保存成功'));
      this.searchFun();
    },
    isChecked(text) {
      return text;
    }
  }
};